import React from 'react';
import { Outlet } from 'react-router-dom';
import PublicHeader from './PublicHeader';
import PublicFooter from './PublicFooter';
import { MenuRouteGate, MenuVisibilityProvider } from '../../contexts/MenuVisibilityContext';
import { useThemeMode } from '../../contexts/ThemeContext';

const PublicLayout = () => {
  const { mode } = useThemeMode();

  return (
    <MenuVisibilityProvider>
      <div className={`public-shell flex min-h-screen flex-col ${mode === 'dark' ? 'dark' : ''}`}>
        <PublicHeader />
        <main className="flex-1 pb-16 lg:pb-0">
          <MenuRouteGate>
            <Outlet />
          </MenuRouteGate>
        </main>
        <PublicFooter />
      </div>
    </MenuVisibilityProvider>
  );
};

export default PublicLayout;
